import { v4 as uuidv4 } from "uuid";
import { NetworkError } from "@/interfaces/errors/networkError";

const prismeApiUrl = process.env.NEXT_PUBLIC_PRISME_API_URL ?? "";

export type AgencyDetails = {
  idAgency: string;
  name: number;
  city: string;
  zipCode: string;
  address: string;
  addressAdditional: string;
  telephone: string;
  email: string;
  gpsLong: number;
  gpsLat: number;
};

export type AgencyDetailsResponse = {
  status: number;
  data: AgencyDetails;
};

export const sendFetchReservationAgencyDetails = (agencyId: string) => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());
  requestHeaders.append("Accept", "/");

  return fetch(
    `${prismeApiUrl}/agencies/getAgencyDetails?language=fr&idAgency=${agencyId}`,
    {
      method: "GET",
      headers: requestHeaders,
    }
  ).then((response) => {
    if (!response.ok) {
      throw new NetworkError(
        `Request returned error ${response.status}`,
        response.status
      );
    }

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
      return response.json();
    } else {
      // calling response.json() with empty response body would throw
      return Promise.resolve({});
    }
  });
};
